import { z } from "zod";

// UUID v4 or generic UUID format
const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export const quoteSchema = z.object({
  firstName: z.string().trim().min(1, "Nome obbligatorio"),
  lastName: z.string().trim().min(1, "Cognome obbligatorio"),
  email: z.string().trim().email("Email non valida"),
  phone: z.string().trim().min(5, "Telefono obbligatorio"),
  address: z.string().trim().optional().nullable(),
  city: z.string().trim().optional().nullable(),
  propertyType: z.string().trim().optional().nullable(),
  serviceId: z
    .string()
    .trim()
    .optional()
    .nullable()
    .transform((v) => (v && v.length > 0 ? v : null)),
  serviceName: z.string().trim().optional().nullable(),
  problemDescription: z.string().trim().optional().nullable(),
  privacyAccepted: z
    .union([
      z.literal("on"),
      z.literal("true"),
      z.boolean().transform((b) => (b ? "on" : "")),
    ])
    .refine((v) => v === "on" || v === "true", {
      message: "Devi accettare la privacy",
    }),
});

export type QuotePayload = z.infer<typeof quoteSchema> & {
  submissionDate?: string;
  source?: string;
};

export function parseQuoteFormData(formData: FormData): QuotePayload {
  const raw = Object.fromEntries(formData.entries());

  const parsed = quoteSchema.safeParse({
    firstName: (raw.firstName as string) ?? "",
    lastName: (raw.lastName as string) ?? "",
    email: (raw.email as string) ?? "",
    phone: (raw.phone as string) ?? "",
    address: (raw.address as string) || undefined,
    city: (raw.city as string) || undefined,
    propertyType: (raw.propertyType as string) || undefined,
    serviceId: (raw.serviceId as string) || undefined,
  serviceName: (raw.serviceName as string) || undefined,
    problemDescription: (raw.problemDescription as string) || undefined,
    privacyAccepted: (raw.privacyAccepted as string) ?? "",
  });

  if (!parsed.success) {
    const firstError = parsed.error.issues[0]?.message || "Dati non validi";
    throw new Error(firstError);
  }

  const data = parsed.data;

  return {
    ...data,
    // Normalize serviceId to valid UUID or null
    serviceId:
      data.serviceId && uuidRegex.test(data.serviceId) ? data.serviceId : null,
    serviceName: data.serviceName || null,
    submissionDate: new Date().toISOString(),
  };
}
